import axios from "axios";
import { getToken } from "./authUtils";

// Create an axios instance with the default headers
const api = axios.create({


// baseURL: "https://api.sarvajna.co.in/qp/controller/",
baseURL: "https://api.sarvajna.co.in/qp/controller/",


  // baseURL: "https://devpanel.online/school_api/qb/controller/", // Your base API URL/

  // imgUrl: "https://devpanel.online/sar-qp/",


  
});

// Add the Authorization header to each request
api.interceptors.request.use(
  (config) => {
    const token = getToken(); // Get the token from localStorage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
